export default __webpack_public_path__ + "img/5cd53787131394dd14701ed6cc40f2ac.svg";